import type {SponsorOptionKey} from "../sponsorOptions";

/**
 * A field the shared option controls can report an error for: one of the option keys, or the logo
 * picker, which only some surfaces mount.
 */
export type OptionErrorField = SponsorOptionKey | "logo";

/**
 * Builds the `errorText` callback the shared option controls take, from a surface's VERDICTS (which
 * option currently fails, keyed by option, valued by an error key) and the CATALOGUE that turns an error
 * key into copy.
 *
 * One definition for every surface that mounts the controls (the booking form's sibling surfaces: the
 * account page-theme picker and the per-transfer builder), so the rule "a logo has no message unless the
 * surface mounts a logo picker, and an option without a verdict has no message" exists once
 * (kitecorp/transferify-ui#1907). React-free on purpose: it is a lookup, not a view.
 */
export function optionErrorText<K extends string>(
	verdicts: Partial<Record<SponsorOptionKey, K>>,
	copy: Record<K, string>,
): (field: OptionErrorField) => string | null {
	return (field) => {
		if (field === "logo") {
			return null;
		}
		const key = verdicts[field];
		return key === undefined ? null : copy[key];
	};
}
